import { useEffect, useState } from "react";
import { IClientSearchProps } from "./ClientSearch.props";
import { useFirstRender } from "@utils/hooks/useFirstRender";

interface SearchElem extends HTMLFormControlsCollection {
  search: HTMLInputElement;
}

interface SearchForm extends HTMLFormElement {
  readonly elements: SearchElem;
}

type SearchFormType = React.FormEvent<SearchForm>;

export interface IClientSearchControl {
  readonly value: string;

  onChangeValue(v: string): void;
  onSearchHandler(): void;
}

export const CLIENT_SEARCH_KEY = "clientS@%*$34234";

const saveClientSearch = (v: string) => {
  localStorage.setItem(CLIENT_SEARCH_KEY, v);
};

export const useClientSearchControl = (
  props: IClientSearchProps
): IClientSearchControl => {
  const firstRender = useFirstRender();
  const [value, setValue] = useState<string>("");

  const onChangeValue = (v: string) => {
    setValue(v);
    if (!v || v.length === 0) {
      localStorage.removeItem(CLIENT_SEARCH_KEY);
    }
  };

  const onSearchHandler = () => {
    props.onSearch(value);
    saveClientSearch(value);
  };

  useEffect(() => {
    if (firstRender) return;
    const t = setTimeout(() => {
      props.onSearch(value);
      saveClientSearch(value);
    }, 500);
    return () => clearTimeout(t);
  }, [value]);

  return {
    value,

    onChangeValue,
    onSearchHandler,
  };
};
